function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useGrid } from '../../hook';

const RESET = ({
  dataIndex,
  inColumn,
  md,
  sm,
  lg,
  xl,
  ...props
}) => {
  const {
    filterReset
  } = useGrid();

  const handleReset = () => {
    filterReset(dataIndex);
  };

  return inColumn ? /*#__PURE__*/React.createElement(Col, {
    className: "mt-4",
    md: md,
    sm: sm,
    lg: lg,
    xl: xl
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleReset
  }, props))) : /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleReset
  }, props));
};

RESET.defaultProps = {
  md: 12,
  sm: 12
};
export default RESET;